import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EE4925",
      "fill-rule": "evenodd",
      d: "M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m2.118-8.118a.45.45 0 0 1 0 .636L6.636 6l1.482 1.482a.45.45 0 0 1-.636.636L6 6.636 4.518 8.118a.45.45 0 0 1-.636-.636L5.364 6 3.882 4.518a.45.45 0 0 1 .636-.636L6 5.364l1.482-1.482a.45.45 0 0 1 .636 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }